module.exports = __webpack_public_path__ + "static/media/LK_Disconnection state.91940637.svg";